import { TReviewBasis } from '../types';

// Built-in review basis catalog. An organization can replace it through
// `mock.review.reviewBases`; ids stay stable so scenario triggers keep matching.
export const DEFAULT_REVIEW_BASES: TReviewBasis[] = [
  { id: 'eu-mdr', label: 'EU MDR', category: 'Regulations', description: 'Regulation (EU) 2017/745' },
  { id: 'eu-ivdr', label: 'EU IVDR', category: 'Regulations', description: 'Regulation (EU) 2017/746' },

  { id: 'mdcg-2020-6', label: 'MDCG 2020-6', category: 'Guidance', description: 'Clinical evidence, legacy devices' },
  {
    id: 'mdcg-2019-11',
    label: 'MDCG 2019-11',
    category: 'Guidance',
    description: 'Qualification and classification of software',
  },
  { id: 'mdcg-2020-1', label: 'MDCG 2020-1', category: 'Guidance', description: 'Clinical evaluation of software' },
  { id: 'mdcg-2022-21', label: 'MDCG 2022-21', category: 'Guidance', description: 'Periodic safety update report' },

  { id: 'iso-14971', label: 'ISO 14971', category: 'Standards', description: 'Risk management' },
  { id: 'iso-13485', label: 'ISO 13485', category: 'Standards', description: 'Quality management system' },
  { id: 'iec-62304', label: 'IEC 62304', category: 'Standards', description: 'Software life cycle' },
  { id: 'iec-62366-1', label: 'IEC 62366-1', category: 'Standards', description: 'Usability engineering' },
  { id: 'iso-14155', label: 'ISO 14155', category: 'Standards', description: 'Clinical investigation' },

  { id: 'internal-sop', label: 'Standard operating procedure', category: 'Internal' },
  { id: 'internal-wi', label: 'Work instruction', category: 'Internal' },

  { id: 'uploaded-pdf', label: 'Uploaded document', category: 'Other', description: 'Add a file for this review' },
];

export const REVIEW_BASIS_CATEGORY_ORDER = ['Regulations', 'Guidance', 'Standards', 'Internal', 'Other'];
